import React from "react";
import AuthService from '../services/AuthService';

const Home = (props) => {
    const ShowText = () => {
        if (AuthService.isAdmin() || AuthService.isStudent()) {
          return ( 
            <>    
              <h1 className='h2'>Welcome to the Voting Booth</h1>
            </>)
        } else {
          return (
              <>
              <h1 className='h2'>You do not have access to this application</h1>
              </>)
        }
      }
return  (
    <ShowText />
);
   
 
}

export default Home;
